module.exports = __webpack_public_path__ + "media/media/values/michael-d-howard-08df8e15206258d71ecd395988d3a12d.jpg";